module.exports = __webpack_public_path__ + "images/elevation-plan-4ca6a1fe49c4a71bee4614a26064c16a.jpg";